<mat-card
  class="list__unit"
  [matTooltip]="'Brugeren er deaktiveret'"
  [matTooltipDisabled]="user.enabled"
  [matBadge]="'!'"
  [matBadgePosition]="'before'"
  [matBadgeHidden]="user.enabled"
  [class.notification--error]="!user.enabled"
  [class.highlight]="user.highlight | async">
  <mat-card-content class="list__unit-card">
    <div class="col col--userName">
      <span>{{ user.userName }}</span>
    </div>
    <div class="col col--fullName">
      <span>{{ user.firstName }} {{ user.lastName }}</span>
    </div>
    <div class="col col--organizationName">
      <a [routerLink]="['/organizations']" class="blue" [queryParams]="{ organizationId: user.organizationId }">
        {{ user.organizationName }}
      </a>
    </div>
    <div class="col col--roles">
      @for (role of user.roles; track role) {
        &middot; {{ role?.description }}<br />
      }
    </div>
    <div class="col col--departmentRestrictions">
      @if (user.departmentRestrictionIds) {
        <span>
          {{ user.departmentRestrictionIds.length }}
          @if (user.departmentRestrictionIds.length === 1) {
            afdeling
          } @else {
            afdelinger
          }
          <mat-icon
            class="outlined margin--left-s"
            [matTooltip]="user.departmentRestrictionNames | tooltipList"
            matTooltipClass="departmentRestrictionNames"
            >info</mat-icon
          >
        </span>
      }
    </div>
    <div class="col col--updated">
      <span>{{ user.updated | date: 'short' }}</span>
    </div>
    <div class="col col--updatedBy">
      <span>{{ user.updatedBy }}</span>
    </div>
    <div class="col col--actions">
      <button mat-icon-button [matMenuTriggerFor]="contextMenu" aria-label="Handlinger" [admRequiresFeatureRole]="roles['user.write']">
        <mat-icon>more_horiz</mat-icon>
      </button>
      <mat-menu #contextMenu="matMenu">
        @if (user.enabled) {
          <button mat-menu-item (click)="openEditUserModal(user)">
            <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
            <span>Rediger bruger</span>
          </button>
        }
        <button mat-menu-item (click)="departmentRestriction(user)">
          <mat-icon>apartment</mat-icon>
          <span>Afdelingsbegrænsninger</span>
        </button>
        <button mat-menu-item (click)="resendInvitation(user)" [admRequiresFeatureRole]="roles['user.write']">
          <mat-icon>forward_to_inbox</mat-icon>
          <span>Gensend oprettelsesmail</span>
        </button>
        <button mat-menu-item (click)="showUserActionLog(user)" [admRequiresFeatureRole]="roles['actions-log.read']">
          <mat-icon>manage_search</mat-icon>
          <span>Vis hændelseslog</span>
        </button>
        @if (user.enabled) {
          <button mat-menu-item (click)="toggleActivationOnUser(user)">
            <mat-icon>block</mat-icon>
            <span>Deaktiver bruger</span>
          </button>
        }
        @if (!user.enabled) {
          <button mat-menu-item (click)="toggleActivationOnUser(user)">
            <mat-icon>check_circle</mat-icon>
            <span>Aktiver bruger</span>
          </button>
        }
      </mat-menu>
    </div>
  </mat-card-content>
</mat-card>
